import { LeverageValues } from "../../models/RushGame";
import { DiceLeverageIcon, FireLeverageIcon, LockedLeverageIcon, SkullLeverageIcon, SnailLeverageIcon } from "../ui/leverage-icons";

function valueToIcon(value:number){
  switch(value) {
    case LeverageValues.VALUE_1:
      return (
        <SnailLeverageIcon />
      );
    case LeverageValues.VALUE_2:
      return (
        <DiceLeverageIcon />
      );
    case LeverageValues.VALUE_3:
      return (
        <FireLeverageIcon />
      );
    case LeverageValues.VALUE_4:
      return (
        <SkullLeverageIcon />
      );
  }
}

interface LeverageItemsProps {
  value: number,
  isLocked?: boolean
}

const LeverageItems: React.FC<LeverageItemsProps> = ({value, isLocked}) => {
  return (
      <div className="w-[105px] flex bg-black medium-button center relative">

        <div className={`${isLocked ? 'visible' : 'hidden' } absolute top-0 right-0 -translate-y-1.5 translate-x-1`}>
          <LockedLeverageIcon/>
        </div>

        <p className="grow center text-white text-2xl">
          x{value}
        </p>

        {valueToIcon(value)}

      </div>
  );
}

export default LeverageItems;